import { Box, Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

export const CustomTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#ffffff",
  },
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: "inherit",
  },
}));

/* ---------------- Custom Button ---------------- */

const StyledButton = styled(Button)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  "&.Mui-disabled": {
    color: "#fff",
    opacity: 0.7,
  },
}));

export const CustomButton = ({
  loading = false,
  children,
  disabled,
  ...props
}) => {
  return (
    <StyledButton
      disabled={loading || disabled}
      {...props}
    >
      {/* Keep original content but hide visually when loading */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {children}
      </Box>

      {/* Absolute loader */}
      {loading && (
        <CircularProgress
          size={20}
          color="inherit"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-10px",
            marginLeft: "-10px",
          }}
        />
      )}
    </StyledButton>
  );
};